module.exports = __webpack_public_path__ + "static/media/invalidLogo.d3d267b8.svg";